import { useNavigate } from 'react-router-dom';
import { useSetupProgress } from '../../../_features/setup/hooks/useSetupProgress';
import { paths } from '../../../_app/router/paths';
import './SetupTracker.scss';

export const SetupTracker = () => {
  const navigate = useNavigate();
  const { completedSetupItems, totalSetupItems, percentage, isComplete } = useSetupProgress();

  if (isComplete || totalSetupItems === 0) {
    return null;
  }

  return (
    <div
      className="setup-tracker"
      onClick={() => navigate(paths.setup)}
    >
      <div className="setup-tracker__content">
        <div className="setup-tracker__header">
          <p>Finish setup</p>
          <span>
            {completedSetupItems} / {totalSetupItems}
          </span>
        </div>
        <div className="setup-tracker__bar">
          <div className="setup-tracker__bar-fill" style={{ width: `${percentage}%` }} />
        </div>
      </div>
    </div>
  );
};
